import React from 'react';
import { Record as RaRecord, SimpleShowLayout, useTranslate } from 'react-admin';
import SectionTitle from '../SectionTitle';
import ConsultationStepSection from './ConsultationStepSection';

import './styles.scss';

interface NutritionAdviceConsultationFormProps {
  record?: RaRecord;
  readOnly?: boolean;
}

const CONSULTATION_STEP_IDS = [
  'bookConsultationWithNutritionistOne',
  'bookConsultationWithNutritionistTwo',
  'bookConsultationWithNutritionistThree',
  'bookConsultationWithNutritionistFour',
  'bookConsultationWithNutritionistFive',
  'bookConsultationWithNutritionistSix',
  'bookConsultationWithNutritionistSeven',
];

const getFileUrl = (stepData: any, documentType: string): string => {
  if (!stepData?.consultationData) {
    return '';
  }

  const { consultationData } = stepData;

  const byUploadedField =
    documentType === 'actionPlan'
      ? consultationData?.uploadedPersonalNutritionActionPlan
      : consultationData?.uploadedSessionDocumentation;

  const byPath = consultationData?.uploadedFiles?.[documentType]?.url;
  const byObject = consultationData?.[documentType]?.url;
  const byDirectUrl = consultationData?.[`${documentType}Url`];

  return byUploadedField || byPath || byObject || byDirectUrl || '';
};

const NutritionAdviceConsultationForm = ({
  record,
  readOnly = false,
}: NutritionAdviceConsultationFormProps) => {
  const translate = useTranslate();

  const consultationSteps = CONSULTATION_STEP_IDS.map((id, index) => ({
    stepData: record?.steps?.find((step: any) => step?.id === id),
    stepNumber: index + 1,
  })).filter(({ stepData }) => stepData && stepData.status !== 'inactive');

  return (
    <SimpleShowLayout>
      <SectionTitle title={translate('nutritionAdvice.consultationForm')} />

      <div className="nutritionAdviceConsultationForm__wrapper">
        {consultationSteps.map(({ stepData, stepNumber }) => (
          <ConsultationStepSection
            key={stepData.id}
            stepData={stepData}
            stepNumber={stepNumber}
            record={record as RaRecord}
            getFileUrl={getFileUrl}
            readOnly={readOnly}
          />
        ))}
      </div>
    </SimpleShowLayout>
  );
};

export default NutritionAdviceConsultationForm;
